import { render } from "./normalButton.vue?vue&type=template&id=a79914f6&scoped=true"
import script from "./normalButton.vue?vue&type=script&lang=js"
export * from "./normalButton.vue?vue&type=script&lang=js"

import "./normalButton.vue?vue&type=style&index=0&id=a79914f6&lang=less&scoped=true"

import exportComponent from "E:\\project\\eyes-system\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a79914f6"]])

export default __exports__